if (!customElements.get('shopify-slideshow')) {
  class ShopifySlideshow extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.slidesContainer = this.querySelector('[data-slideshow-slides]');
      this.slides = Array.from(this.querySelectorAll('[data-slideshow-slide]'));
      this.dotsContainer = this.querySelector('[data-slideshow-dots]');
      this.currentIndexSpan = this.querySelector('[data-slideshow-current-index]');
      this.prevBtn = this.querySelector('[data-slideshow-prev]');
      this.nextBtn = this.querySelector('[data-slideshow-next]');
      
      if (this.slides.length <= 1) return; 

      this.settings = {
        autoPlay: this.dataset.autoPlay === 'true',
        speed: parseInt(this.dataset.speed) || 5000,
        total: this.slides.length,
      };

      this.currentSlideIndex = 1; 
      this.autoplayTimer = null;

      this.init();
    }

    init() {
      this.initNavigation();
      this.initAutoplay();
      
      document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
    }

    initNavigation() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.changeSlide(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.changeSlide(1));
      }

      if (this.dotsContainer) {
        this.dots = Array.from(this.dotsContainer.querySelectorAll('[data-slideshow-dot]'));
        this.dots.forEach(dot => {
          dot.addEventListener('click', () => {
            const targetIndex = parseInt(dot.dataset.index);
            if (targetIndex !== this.currentSlideIndex) {
              this.goToSlide(targetIndex);
            }
          });
        });
      }
    }

    initAutoplay() {
      if (!this.settings.autoPlay) return;

      this.startAutoplay();

      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => this.startAutoplay());
      this.container.addEventListener('touchstart', () => this.stopAutoplay(), {passive: true});
      this.container.addEventListener('touchend', () => this.startAutoplay());
    }

    startAutoplay() {
      if (this.autoplayTimer) return;
      this.autoplayTimer = setInterval(() => {
        this.changeSlide(1);
      }, this.settings.speed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    /**
     * 相对切换
     * @param {number} direction - 1 为下一张，-1 为上一张
     */
    changeSlide(direction) {
      let nextIndex = this.currentSlideIndex + direction;
      
      if (nextIndex > this.settings.total) {
        nextIndex = 1; // 循环到第一张
      } else if (nextIndex < 1) {
        nextIndex = this.settings.total; // 循环到最后一张
      }
      
      this.goToSlide(nextIndex);
    }

goToSlide(index) {
  this.currentSlideIndex = index;

  // 1. 让对应的 Slide 显现
  this.slides.forEach(slide => {
    if (parseInt(slide.dataset.index) === index) {
      slide.classList.add('is-active');
    } else {
      slide.classList.remove('is-active');
    }
  });

  // 2. 更改下方点控制器的样式高亮
  if (this.dots) {
    this.dots.forEach(dot => {
      if (parseInt(dot.dataset.index) === index) {
        dot.classList.add('bg-white', 'scale-110');
        dot.classList.remove('bg-white/40');
      } else {
        dot.classList.remove('bg-white', 'scale-110');
        dot.classList.add('bg-white/40');
      }
    });
  }

  // 3. 更新页码
  if (this.currentIndexSpan) {
    this.currentIndexSpan.textContent = index;
  }
}
    onBlockSelect(event) {
      if (!this.contains(event.target)) return;
      
      const slideBlock = event.target.matches('[data-slideshow-slide]') 
        ? event.target 
        : event.target.closest('[data-slideshow-slide]');

      if (slideBlock) {
        const indexToSelect = parseInt(slideBlock.dataset.index);
        this.stopAutoplay();
        this.goToSlide(indexToSelect);
      }
    }
  }
  customElements.define('shopify-slideshow', ShopifySlideshow);
}